"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormPickerInput = void 0;
const tslib_1 = require("tslib");
const components_1 = require("@bluebase/components");
const core_1 = require("@bluebase/core");
const formik_1 = require("formik");
const react_1 = tslib_1.__importDefault(require("react"));
const BaseFormField = core_1.getComponent('BaseFormField');
const FormPickerInput = (_a) => {
    var { type, items } = _a, props = tslib_1.__rest(_a, ["type", "items"]);
    const [field, , helpers] = formik_1.useField(props);
    const { setValue } = helpers;
    const inputProps = Object.assign(Object.assign(Object.assign({}, props), field), { onValueChange: setValue, selectedValue: field.value });
    return (react_1.default.createElement(BaseFormField, Object.assign({ MainComponent: components_1.Picker }, inputProps), items.map(i => react_1.default.createElement(components_1.Picker.Item, Object.assign({ key: String(i.value) }, i)))));
};
exports.FormPickerInput = FormPickerInput;
exports.FormPickerInput.defaultProps = {};
